import PLAYERTRACK_TYPE from '../../containers/Music/playerTracksType';
import * as api from "../../requests/loader";
import PlayerTracksUtil from "../../utils/PlayerTracksUtils";
import { AAFPLAYER_PLAY } from "../../AAFPlayer/constants";
import logger from 'src/utils/logger/logger';

export default class MusicActionsUtil {
  /**
   *
   * @param {object} data example: { type: string, id: string, isFollowed: boolean}
   */
  static async toggleFollow(data) {
    if (!data.type || !data.id) {
      return Promise.reject("invalid data");
    }
    let response;
    switch (data.type) {
      case PLAYERTRACK_TYPE.ALBUM:
        response = await api.toggleFollow("/user/followToggleAlbum", {
          contentId: data.id,
        });
        break;
      case PLAYERTRACK_TYPE.ARTIST:
        response = await api.toggleFollow("/user/followToggleArtist", {
          contentId: data.id,
        });
        break;
      case PLAYERTRACK_TYPE.PLAYLIST:
        if (data.isFollowing) {
          response = await api.toggleFollow("/user/unfollowPlaylist", {
            contentId: data.id,
          });
        } else {
          response = await api.toggleFollow("/user/followPlaylist", {
            contentId: data.id,
          });
        }
        break;
      case PLAYERTRACK_TYPE.SONG:
        response = await api.toggleFollow("/user/toggleFavoriteSong", {
          contentId: data.id,
        });
        break;
      case PLAYERTRACK_TYPE.RADIO:
        if (data.isFollowing) {
          response = await api.toggleFollow("/user/unfollowRadio", {
            contentId: data.id,
          });
        } else {
          response = await api.toggleFollow("/user/followRadio", {
            contentId: data.id,
          });
        }
        break;
      default:
        return Promise.reject("undefined type");
    }
    logger.debug("[MusicActionsUtil] toggleFollow response", response);
    if (response && (response.status || response.success))
      return Promise.resolve(response.status || response.success);
    return Promise.reject(false);
  }

  /**
   *
   * @param {object} data example: { type: string, id: string, isFollowed: boolean}
   */
  static playContent(data, pgmAction, playFullMediaAction, index = 0) {
    const playerTracks = new PlayerTracksUtil();
    if (
      !data.type ||
      !data.id ||
      !typeof playFullMediaAction === "function" ||
      !typeof pgmAction === "function"
    ) {
      throw new Error("invalid params");
    }
    const sendToPlay = (pgm, isLive = false) => {
      if (pgm && pgm.media && pgm.media.video_url) {
        playFullMediaAction({
          playerstate: AAFPLAYER_PLAY,
          source: {
            audiosource: pgm.media.video_url,
          },
          ispreview: false,
          islive: isLive,
          ispip: false,
        });
      }
    };
    switch (data.type) {
      case PLAYERTRACK_TYPE.ALBUM:
        api
          .getAlbumDetail({
            album_id: data.id,
          })
          .then((response) => {
            const { data: { volumes = [] } = {} } = response;
            playerTracks
              .getPlayerTracks(data.type, data.id)
              .then((resp) => {
                const pgm_musica = pgmAction(0, {
                  volumes,
                  playerTracks: resp,
                });
                sendToPlay(pgm_musica);
              })
              .catch((err) => {
                logger.debug("[playContent] err", err);
              });
          })
          .catch((err) => logger.debug(err));
        break;
      case PLAYERTRACK_TYPE.ARTIST:
        const { tracks = [] } = data;
        const pgm_musica = pgmAction(index, {
          tracks,
        });
        sendToPlay(pgm_musica);
        break;
      case PLAYERTRACK_TYPE.PLAYLIST:
        api
          .getPlaylistDetail({
            list_id: data.id,
          })
          .then((response) => {
            const { data: { tracks = [] } = {} } = response;
            playerTracks
              .getPlayerTracks(data.type, data.id)
              .then((resp) => {
                const pgm_musica = pgmAction(0, {
                  playlistDetail: {
                    tracks,
                    playerTracks: resp,
                  },
                });
                sendToPlay(pgm_musica);
              })
              .catch((err) => {
                logger.debug("[playContent] err", err);
              });
          })
          .catch((err) => logger.debug(err));
        break;
      case PLAYERTRACK_TYPE.SONG:
        throw new Error("Not implement yet");
      default:
        throw new Error("undefined type");
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/music/MusicActionsUtil.js